module.exports = __webpack_public_path__ + "media/07 barely.ef8659ba.mp3";